import { useTemplateData } from "@constants/template";
import { t } from "i18next";
import React from "react";

import { PhoneIcon } from "@components/SvgIcons/PhoneIcon";
import { ItineraryIcon } from "@components/SvgIcons/ItineraryIcon";
import { NotFavoriteIcon } from "@components/SvgIcons/NotFavoriteIcon";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import { CheckIcon } from "@aureskonnect/react-ui";

interface ShopPagePreviewProps {
    imagePath: string[];
    logoPath: string[];
    selectedRows: any;
    PhoneNumber: string;
}
function ShopPagePreview({
    imagePath,
    logoPath,
    selectedRows,
    PhoneNumber,
}: ShopPagePreviewProps) {
    const { getImageUrl, iuud, getNestedValue } = useTemplateData();
    const imageUrlImage = getImageUrl(imagePath, iuud);
    const imageUrlLogo = getImageUrl(logoPath, iuud);
    const mainColor = getNestedValue<any>([
        "SiteWeb",
        "Divers",
        "CouleurPrincipale",
    ]);
    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",

                height: "80vh",
                borderLeft: "1px #c6c7c9 solid",
            }}
        >
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "98%",
                    height: "50%",
                    border: "2px solid black",
                    backgroundColor: "white",
                }}
            >
                {" "}
                <div style={{ width: "50%", height: "100%" }}>
                    {imageUrlImage !== "" && (
                        <img
                            src={imageUrlImage}
                            alt=""
                            style={{ width: "100%", height: "100%" }}
                            key={imageUrlImage}
                        />
                    )}
                </div>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "space-between",
                        padding: "10px",
                        width: "50%",
                        height: "100%",
                        borderLeft: "1px #c6c7c9 solid",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        {imageUrlLogo !== "" && (
                            <div style={{ width: "60px", height: "60px" }}>
                                <img
                                    src={imageUrlLogo}
                                    alt=""
                                    style={{ width: "100%", height: "100%" }}
                                    key={imageUrlLogo}
                                />
                            </div>
                        )}
                        <h4
                            style={{
                                textAlign: "center",
                            }}
                        >
                            Informations de la boutique
                        </h4>
                    </div>

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "5px",
                            paddingTop: "0px",
                            gap: "15px",
                            alignItems: "center",
                        }}
                    >
                        <span
                            style={{
                                borderBottom: `1px ${mainColor} solid`,
                            }}
                        >
                            {t("General")}
                        </span>
                        <span>{t("Opening hours")}</span>
                        <span>{t("Delivery city")}</span>
                    </div>
                    <div
                        style={{
                            height: "18vh",
                            padding: "5px",
                            marginBottom: "5px",
                            overflow: "auto",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-evenly",
                            }}
                        >
                            <div
                                style={{
                                    border: `1px ${mainColor} solid`,
                                    color: `${mainColor}`,
                                    borderRadius: "5px",
                                    padding: "5px",
                                    width: "30%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    height: "40px",
                                    gap: "5px",
                                }}
                            >
                                <NotFavoriteIcon color={`${mainColor}`} />

                                <span style={{ fontSize: "12px" }}>
                                    {t("Favorite shop")}
                                </span>
                            </div>
                            <div
                                style={{
                                    backgroundColor: `${mainColor}`,
                                    borderRadius: "5px",
                                    padding: "5px",
                                    width: "30%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    height: "40px",
                                    gap: "5px",
                                }}
                            >
                                <ItineraryIcon />
                                <span style={{ fontSize: "12px" }}>
                                    {t("Itinerary")}
                                </span>
                            </div>
                            <div
                                style={{
                                    border: `1px ${mainColor} solid`,
                                    color: `${mainColor}`,
                                    borderRadius: "5px",
                                    padding: "5px",
                                    width: "30%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "5px",
                                    height: "40px",
                                }}
                            >
                                <PhoneIcon color={`${mainColor}`} />
                                <span style={{ fontSize: "12px" }}>
                                    {t("Call")}
                                </span>
                            </div>
                        </div>
                        <h6 style={{ padding: "5px 10px" }}>
                            {selectedRows[0].Adresse}
                        </h6>
                        <h6 style={{ padding: "0px 10px" }}>{PhoneNumber}</h6>
                        <div style={{ padding: "5px 10px" }}>
                            <h6 style={{ fontSize: "bold" }}>
                                {t("Sales mode")}
                            </h6>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    flexWrap: "wrap",
                                    padding: "5px 10px",
                                    gap: "10px",
                                }}
                            >
                                <span
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "5px",
                                    }}
                                >
                                    <CheckIcon
                                        color="green"
                                        height={15}
                                        width={15}
                                        style={{
                                            fill: "green",
                                        }}
                                    />{" "}
                                    {t("On the spot")}
                                </span>
                                <span
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "5px",
                                    }}
                                >
                                    <CheckIcon
                                        color="green"
                                        height={15}
                                        width={15}
                                        style={{
                                            fill: "green",
                                        }}
                                    />{" "}
                                    {t("To take")}
                                </span>
                                <span
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "5px",
                                    }}
                                >
                                    <CheckIcon
                                        color="green"
                                        height={15}
                                        width={15}
                                        style={{
                                            fill: "green",
                                        }}
                                    />{" "}
                                    {t("In delivery")}
                                </span>
                            </div>
                        </div>
                        <div style={{ padding: "5px 10px" }}>
                            <h6 style={{ fontSize: "bold" }}>
                                {t("Means of payment")}
                            </h6>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    flexWrap: "wrap",
                                    padding: "5px 10px",
                                    gap: "10px",
                                }}
                            >
                                {" "}
                                <span
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "5px",
                                    }}
                                >
                                    <CheckIcon
                                        color="green"
                                        height={15}
                                        width={15}
                                        style={{
                                            fill: "green",
                                        }}
                                    />{" "}
                                    {t("Cash")}
                                </span>
                                <span
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "5px",
                                    }}
                                >
                                    <CheckIcon
                                        color="green"
                                        height={15}
                                        width={15}
                                        style={{
                                            fill: "green",
                                        }}
                                    />{" "}
                                    {t("Bank card")}
                                </span>
                                <span
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "5px",
                                    }}
                                >
                                    <CheckIcon
                                        color="green"
                                        height={15}
                                        width={15}
                                        style={{
                                            fill: "green",
                                        }}
                                    />{" "}
                                    {t("Fidelity")}
                                </span>
                                <span
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "5px",
                                    }}
                                >
                                    <CheckIcon
                                        color="green"
                                        height={15}
                                        width={15}
                                        style={{
                                            fill: "green",
                                        }}
                                    />{" "}
                                    {t("Check")}
                                </span>
                                <span
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "5px",
                                    }}
                                >
                                    <CheckIcon
                                        color="green"
                                        height={15}
                                        width={15}
                                        style={{
                                            fill: "green",
                                        }}
                                    />{" "}
                                    {t("Ticket restaurant")}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <CustomSecondaryColorButton
                            rounded
                            block
                            style={{
                                width: "90%",
                                backgroundColor: `${mainColor}`,
                            }}
                        >
                            {t("Validate")}
                        </CustomSecondaryColorButton>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ShopPagePreview;
